import { RouteDtoModelType } from '../../../../store/mst/models';

const getRouteColors = (sortedRoutes: RouteDtoModelType[], driverId: string): string[] => sortedRoutes.reduce((acc, route) => {
  if (route.driver?.id === driverId && route.hexColor) {
    acc.push(route.hexColor);
  }
  return acc;
}, [] as string[]);

export default getRouteColors;
